import { useAppContext } from "../hooks/context"
import Indicator from "./loader"
import React from "react"

export function GlobalIndicator() {
  const { isLoading } = useAppContext()
  return <Indicator show={isLoading} />
}
